import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { mostraAlerta } from "../../componentes/alerts/sweetAlert";
import { AxiosPublico } from "../../componentes/axios/Axios";
import { UsuarioActualizarContrasena } from "../../configuracion/apiUrls";
import { NegocioConfig } from "../../configuracion/Empresa";

const ActualizarContrasena = () => {
  const [correo, setCorreo] = useState("");
  const [pin, setPin] = useState("");
  const [contrasena, setContrasena] = useState("");
  const [verificarContrasena, setVerificarContrasena] = useState("");
  const [showPasswordNueva, setShowPasswordNueva] = useState(false); // Visibilidad para nueva contraseña
  const [showPasswordVerificar, setShowPasswordVerificar] = useState(false); // Visibilidad para verificar contraseña
  const [errorMatch, setErrorMatch] = useState(false);

  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (errorMatch) {
      mostraAlerta("Las contraseñas no coinciden", "warning");
      return;
    }
    try {
      if (
        correo.trim() === "" ||
        pin.trim() === "" ||
        contrasena.trim() === ""
      ) {
        mostraAlerta("Complete todos los campos", "warning");
        return;
      }
      const response = await AxiosPublico.post(UsuarioActualizarContrasena, {
        correo: correo.trim(),
        pin: pin.trim(),
        contrasena: contrasena.trim(),
      });
      mostraAlerta("Contraseña actualizada correctamente", "success");
      console.log(response.data);
      setTimeout(() => navigate("/login"), 2000);
    } catch (error) {
      console.log("Error:", error);
      if (error.response) {
        if (Array.isArray(error.response.data)) {
          error.response.data.forEach((f) => {
            mostraAlerta("Campo: " + f.path + ". " + f.msg, "warning");
          });
        } else if (error.response.data.error) {
          mostraAlerta(error.response.data.error, "warning");
        } else {
          mostraAlerta("Error al actualizar la contraseña", "error");
        }
      } else {
        mostraAlerta("Error de red o servidor no disponible", "error");
      }
    }
  };

  const handlePasswordChange = (value) => {
    setContrasena(value);
    setErrorMatch(value !== verificarContrasena);
  };

  const handleVerifyPasswordChange = (value) => {
    setVerificarContrasena(value);
    setErrorMatch(value !== contrasena);
  };

  return (
    <div className="hold-transition login-page">
      <div className="login-box">
        <div
          className="login-logo"
          style={{ display: "flex", justifyContent: "center" }}
        >
          <img
            src={NegocioConfig.logo}
            alt="SIGVEM LOGO"
            className="img-fluid img-circle"
            style={{ width: "250px", height: "250px" }}
          />
        </div>
        <div className="card card-outline">
          <div className="card-body">
            <h4 className="login-box-msg">Actualizar Contraseña</h4>
            <form onSubmit={handleSubmit}>
              <div className="input-group mb-3">
                <input
                  type="email"
                  className="form-control"
                  placeholder="Correo Electrónico"
                  value={correo}
                  onChange={(e) => setCorreo(e.target.value)}
                  autoComplete="email"
                />
                <div className="input-group-append">
                  <div className="input-group-text">
                    <span className="fas fa-envelope"></span>
                  </div>
                </div>
              </div>
              <div className="input-group mb-3">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Introduce tu PIN"
                  value={pin}
                  onChange={(e) => setPin(e.target.value)}
                  autoComplete="one-time-code"
                />
                <div className="input-group-append">
                  <div className="input-group-text">
                    <span className="fas fa-key"></span>
                  </div>
                </div>
              </div>
              <div className="input-group mb-3">
                <input
                  type={showPasswordNueva ? "text" : "password"}
                  className="form-control"
                  placeholder="Nueva Contraseña"
                  value={contrasena}
                  onChange={(e) => handlePasswordChange(e.target.value)}
                  autoComplete="new-password"
                />
                <div className="input-group-append">
                  <div
                    className="input-group-text"
                    onClick={() => setShowPasswordNueva(!showPasswordNueva)}
                    style={{ cursor: "pointer" }}
                  >
                    <span
                      className={
                        showPasswordNueva ? "fas fa-eye-slash" : "fas fa-eye"
                      }
                    ></span>
                  </div>
                </div>
              </div>
              <div className="input-group mb-3">
                <input
                  type={showPasswordVerificar ? "text" : "password"}
                  className="form-control"
                  placeholder="Verificar Contraseña"
                  value={verificarContrasena}
                  onChange={(e) => handleVerifyPasswordChange(e.target.value)}
                  autoComplete="new-password"
                />
                <div className="input-group-append">
                  <div
                    className="input-group-text"
                    onClick={() =>
                      setShowPasswordVerificar(!showPasswordVerificar)
                    }
                    style={{ cursor: "pointer" }}
                  >
                    <span
                      className={
                        showPasswordVerificar
                          ? "fas fa-eye-slash"
                          : "fas fa-eye"
                      }
                    ></span>
                  </div>
                </div>
              </div>
              {errorMatch && (
                <small className="text-danger">
                  Las contraseñas no coinciden
                </small>
              )}
              <div className="row">
                <div className="col-12">
                  <button
                    type="submit"
                    className="btn btn-primary btn-block btn-lg"
                    disabled={errorMatch}
                  >
                    Actualizar Contraseña
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ActualizarContrasena;
